import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Helmet } from 'react-helmet'

const GoogleFontsLoader = observer(() => {
  const { googleFonts } = useRootStore()

  useEffect(
    function fetchFonts() {
      if (!googleFonts.ready) {
        googleFonts.fetchAll()
      }
    },
    [googleFonts],
  )

  return (
    <Helmet>
      {googleFonts.getByLoadingState('loading', 'loaded').map((font) => (
        <link key={font.family} href={font.url} rel="stylesheet" />
      ))}
    </Helmet>
  )
})

export { GoogleFontsLoader }
